// Default XML data checks, relevant to the datasets for all tools.
const defaultChecks = (xmlData) => {
  if (!Array.isArray(xmlData)) {
    return false
  }

  if (xmlData.length === 0) {
    console.error('Validation failed: "dataset.record" array is empty.')

    return false
  }

  return true
}

export const xmlDataValidation = ({ xmlData, dataValidation }: XmlDataValidation) => {
  // Test against checks that apply to all tools
  if (!defaultChecks(xmlData) || !xmlData) {
    return false
  }

  for (const record of xmlData) {
    const recordKeys = Object.keys(record)
    if (!dataValidation.every((key) => recordKeys.includes(key))) {
      console.error('Validation failed: An item in xmlData is missing expected keys.', record)

      return false
    }
  }

  return true
}

type XmlDataValidation = {
  xmlData:
    | {
        [key: string]: string
      }[]
    | undefined
    | null
  dataValidation: string[]
}
